import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';

import Home from './components/Views/Home';
import PageNotFound from './components/Views/PageNotFound';
import Products from './components/Views/Products';
import ProductDetails from './components/Views/ProductDetails';

export default class App extends Component {

  render() {
    return (
      <Switch>
        <Route exact path='/' component={ Home } />
        <Route exact path='/products' component={ Products } />
        <Route exact path='/products/:key' component={ ProductDetails } />
        <Route exact path='/404' component={ PageNotFound } />
        <Route path='*' component={ PageNotFound } />
      </Switch>
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/routes.js